<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addHqActivityDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addHqActivityFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="物料模板名称" prop="activityName">
            <el-input v-model="formData.activityName" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
export default {
  data () {
    return {
      rules: {
        activityName: [
          { required: true, message: '请输入物料模板名称', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {
        isBatchApprove: '0'
      },
      marketList: []
    };
  },
  props: {
    addHqActivityVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addHqActivityVisible (val) {
      if (val) {
        if (this.rowData.id) {
          let rowData = JSON.parse(JSON.stringify(this.rowData));
          rowData.isBatchApprove = `${this.rowData.isBatchApprove}`;
          this.formData = rowData;
        }
      } else {
        this.formData = {};
        this.$nextTick(() => {
          this.$refs.addHqActivityFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitHandlen () {
      this.$refs['addHqActivityFrom'].validate(valid => {
        if (valid) {
          let params = {
            activityName: this.formData.activityName,
            htType: 1
          };
          if (this.formData.id) {
            params.id = this.formData.id;
            this.$emit('editHqActivitySubHandle', params);
          } else {
            this.$emit('addHqActivitySubHandle', params);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    getMarketList () {
      newApplicationFormApi.getMarketList('000').then(res => {
        if (res.status === '200') {
          this.marketList = res.data;
        }
      });
    }
  },
  mounted () {
    this.getMarketList();
  }
};
</script>

<style scoped>

</style>
